<template lang="pug">
BlueSearch
  template
    .searchResults
      .searchResults-utility
        SearchQuery
          template(
            v-slot="{ query, setQuery, sort, setSort, results, executeSearch, currentResultsStart, currentResultsEnd }"
          )
            Query(
              :query="query",
              :setQuery="setQuery",
              :sort="sort",
              :setSort="setSort",
              :results="results",
              :currentResultsStart="currentResultsStart",
              :currentResultsEnd="currentResultsEnd",
              :executeSearch="executeSearch"
            )
      .searchResults-list
        SearchResults
          template(#item="{ result, openInNewWindow, formatDate }")
            Result(
              :result="result",
              :openInNewWindow="openInNewWindow",
              :formatDate="formatDate"
            )
      SearchPagination
</template>

<script>
import Query from "./components/Query.vue";
import Result from "./components/Result.vue";
export default {
  name: "FSCSearch",
  components: {
    Query,
    Result,
  },
};
</script>

<style lang="scss" scoped>
#bluesearch {
  --link-color: #{$darkBlue};
  --loader-color: #{$darkBlue};
  --pagination-number-color: #{$darkGray};
  --pagination-number-background: transparent;
  --pagination-number-hover-color: #{$white};
  --pagination-number-hover-background: #{$gray};
  --pagination-number-active-color: #{$white};
  --pagination-number-active-background: #{$darkBlue};
  --pagination-nav-hover-background: #{$darkBlue};
}

.searchResults {
  display: flex;
  flex-direction: column;
  width: 100%;
}
</style>